import {
  useTenantList,
  useGetTenantByFriendly,
} from "@/hooks/queryHooks/tenantHooks";
import type { TenantContextType } from "@/hooks/routes/useTenant";
import { useProtected } from "@/hooks/useProtected";
import { useTenantStore } from "@/stores/tenantStore";
import { useUserStore } from "@/stores/userStore";
import { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

export const TenantRoot = () => {
  const navigate = useNavigate();
  useProtected();
  const { tenantId } = useParams();
  const { loaded: tenantLoaded, data: tenantData } = useGetTenantByFriendly(
    tenantId ?? ""
  );
  const { data: accessibleTenants } = useTenantList();
  const setTenant = useTenantStore((s) => s.setTenant);
  const setActiveTenant = useUserStore((s) => s.setActiveTenant);

  useEffect(() => {
    if (!tenantData || !accessibleTenants) return;

    const tenantIsAccessible = accessibleTenants.some(
      (tenant) => tenant.id === tenantData.id
    );

    if (!tenantIsAccessible) {
      navigate(`/app`);
      return;
    }

    setTenant(tenantData);
    setActiveTenant(tenantData);
    if (
      tenantData &&
      (!tenantData.subscriptionId || tenantData.subscriptionStatus !== "active")
    ) {
      navigate(`/subscription?tenantId=${tenantData.id}&stepId=1`);
    }
  }, [setTenant, tenantData, navigate, setActiveTenant, accessibleTenants]);

  return (
    <Outlet
      context={
        {
          tenant: tenantData,
          isLoading: !tenantLoaded,
        } satisfies TenantContextType
      }
    />
  );
};

export { DashboardPage } from "./Dashboard";
